import axios from "axios";
import config from "@/config/constants";
import store from "./src/store";

export const getServices = async () => {
  // uncomment for development only
  // const response = await axios.get('/my_health.json');
  // return response

  const payload = {
    user_id: store.getters.user_id
  };
  const res = await axios.post(
    config.api_env + "/application/api/u/dmh/get-services",
    payload,
    config.options
  );
  return res;
};

export const getNavigationTags = async () => {
  // uncomment for development only
  // const response = await axios.get('/navigation_tags.json');
  // return response

  const payload = {
    user_id: store.getters.user_id
  };
  const res = await axios.post(
    config.api_env + "/application/api/u/dmh/get-navigation-tags",
    payload,
    config.options
  );
  return res;
};
